import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { ReplaceTextPipe } from "../../../shared/pipe/replace-text.pipe";

@Component({
  selector: 'app-check-in-details',
  standalone: true,
  imports: [AppButtonComponent, ReplaceTextPipe],
  templateUrl: './check-in-details.component.html',
  styleUrl: './check-in-details.component.scss'
})
export class CheckInDetailsComponent implements OnInit {


  checkinData: any = null;
  waveData: any = null;
  copiado = false;

  buttonOptions = {
    buttonText: 'Voltar',
    buttonBorderWidth: '1px',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px',
  };

  constructor(private location: Location, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }

    this.checkinData = history.state.checkin;
    this.waveData = history.state.game;

    console.log(this.checkinData, "opa")

    this.cdr.detectChanges();
  }

  copiarCodigo(): void {
    this.copiado = false;
    if (!this.checkinData?.ticketCode) return;

    navigator.clipboard.writeText(this.checkinData.ticketCode).then(() => {
      this.copiado = true;
    }).catch(err => {
      console.error('Erro ao copiar o código:', err);
    });
  }

  getName() {
    let nome = '';

    if (this.checkinData.isGuest) {
      nome = this.checkinData.memberGuestName + ' - CONVIDADO(A)';
    } else if (this.checkinData.isDependent) {
      nome = this.checkinData.memberDependentName + ' - DEPENDENTE';
    } else if (this.checkinData.isSubstitute) {
      nome = this.checkinData.memberSubstituteName + ' - SUBSTITUTO(A)';
    } else {
      nome = this.checkinData.memberPlanName + ' - SÓCIO(A)';
    }
    return nome;
  }

  back(): void {
    this.location.back();
  }

}
